import { render } from "./MessageBadgeOutline.vue.js?vue&type=template&id=fd0bc52a!=!../vue-loader/dist/index.js??ruleSet[0]!./MessageBadgeOutline.vue?vue&type=template&id=fd0bc52a"
import script from "./MessageBadgeOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./MessageBadgeOutline.vue?vue&type=script&lang=js"
export * from "./MessageBadgeOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./MessageBadgeOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__